import axios from "axios";
import settings from "utils/settings";
import filterTypes from "data/filter-types";
import createQuery from "../../helpers/create-query";

const apiUrl = `${settings.apiUrl}api/`;

export const requestGetCurrencies = () =>
  axios.get(`${apiUrl}transaction/currencies`);

export const requestGetStatuses = () =>
  axios.get(`${apiUrl}transaction/statuses`);

export const requestGetTypes = () =>
  axios.get(`${apiUrl}transaction/providers`);

export const requestRefund = transactionId =>
  axios.patch(`${apiUrl}transaction/refund/${transactionId}`);

export const requestExport = (userId) => {
  const query = createQuery({}, {
    page: 0,
    size: 100000,
    sort: "startDate,DESC"
  });
  return axios.post(`${apiUrl}transaction/export?${query}`, {
    criteria: [{
      fieldName: "walletId",
      fieldValue: userId,
      searchOperation: filterTypes.EQUALS.value
    }]
  }, {
    contentType: "application/json;charset=utf-8",
    responseType: "blob",
  });
};



// WEBPACK FOOTER //
// ./src/actions/transaction/requests.js